import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { useI18n } from "../lib/i18n";

const ANY = "__any";

export function Sel({ value, onChange, options, placeholder, testid, label, className = "", noAny = false }) {
  const { isRtl } = useI18n();
  return (
    <Select dir={isRtl ? "rtl" : "ltr"} value={value ? String(value) : ANY} onValueChange={(v) => onChange(v === ANY ? "" : v)}>
      <SelectTrigger data-testid={testid} aria-label={label || placeholder} className={`h-12 rounded-sm border-fg/15 bg-canvas/60 text-sm text-fg focus:ring-cta ${className}`}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-72 border-cta/20 bg-surface text-fg">
        {!noAny && <SelectItem value={ANY} data-testid={`${testid}-option-any`}>{placeholder}</SelectItem>}
        {options.map(([v, l]) => (
          <SelectItem key={v} value={String(v)} data-testid={`${testid}-option-${v}`} className="focus:bg-brand focus:text-cta">{l}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export const FieldLabel = ({ htmlFor, children, optional }) => {
  const { t } = useI18n();
  return (
    <label htmlFor={htmlFor} className="mb-2 block text-xs font-medium uppercase tracking-wider text-fg/60">
      {children}{optional && <span className="ms-1 normal-case tracking-normal text-fg/35">({t("form.optional")})</span>}
    </label>
  );
};
